module.exports = __webpack_public_path__ + "img/poster_headerImg_default.2a94ff5b.png";